"use client";

import Image from "next/image";
import loaderGif from "@/assets/images/loader.gif";
import "@/components/Layout/layout.css";

export type SpinnerOverlayProps = {
  /** Extra classes for the overlay wrapper (e.g. "!bg-white"). */
  className?: string;
};

const SpinnerOverlay = ({ className }: SpinnerOverlayProps = {}) => (
  <div className={["spinner-overlay", className].filter(Boolean).join(" ")}>
    <Image
      src={loaderGif}
      alt="Loading"
      className="spinner-gif"
      width={55}
      height={55}
      unoptimized
      priority
    />
  </div>
);

export default SpinnerOverlay;
